export default function Signification() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="qui-sommes-nous" className="relative bg-[#0A0A0A] py-16 sm:py-24 lg:py-32 px-4 sm:px-6 overflow-hidden">
      <div className="absolute top-10 left-10 w-32 sm:w-48 md:w-64 h-32 sm:h-48 md:h-64 opacity-10">
        <svg viewBox="0 0 200 200" className="w-full h-full">
          <path d="M50,100 Q75,50 100,75 T150,100" stroke="#666" fill="none" strokeWidth="1"/>
          <circle cx="50" cy="100" r="3" fill="#666"/>
          <circle cx="100" cy="75" r="3" fill="#666"/>
          <circle cx="150" cy="100" r="3" fill="#666"/>
        </svg>
      </div>

      <div className="max-w-6xl mx-auto text-center">
        <p className="text-xs tracking-widest text-gray-400 uppercase mb-6 sm:mb-8">
          Origine & Signification
        </p>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif text-white/95 leading-tight mb-16 sm:mb-24 lg:mb-32 px-4">
          OTOROBOTS n'est pas
          <br />
          une question de machines.
          <br />
          C'est une question de lien.
        </h2>

        <div className="grid sm:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 max-w-5xl mx-auto mb-12 sm:mb-16">
          <div className="text-left px-4">
            <h3 className="text-xl sm:text-2xl font-light text-white mb-3 sm:mb-4">OTO</h3>
            <p className="text-sm sm:text-base font-light text-white/80 leading-relaxed">
              L'automatisation des systèmes, des processus, de ce qui alourdit l'expérience humaine. Structurer ce qui clarifie.
            </p>
          </div>

          <div className="text-left px-4">
            <h3 className="text-xl sm:text-2xl font-light text-white mb-3 sm:mb-4">ROBOTS</h3>
            <p className="text-sm sm:text-base font-light text-white/80 leading-relaxed">
              Les formes d'intelligence non humaines, notamment l'IA, au service de la clarté et de l'autonomie. Libérer ce qui est profondément humain.
            </p>
          </div>
        </div>

        <button
          onClick={() => scrollToSection('raison-etre')}
          className="inline-block px-8 sm:px-10 py-3 sm:py-4 bg-[#D4A5A5] text-black text-sm sm:text-base font-medium rounded-full hover:bg-[#C89595] transition-colors cursor-pointer whitespace-nowrap"
        >
          Découvrir notre raison d'être
        </button>
      </div>
    </section>
  );
}
